import "./styles/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { FormLayout } from "./layouts/FormLayout/FormLayout";
import { ReserveFormLayout } from "./layouts/ReserveFormLayout/ReserveFormLayout";
import BaseLayout from "./layouts/BaseLayout";
import { Heading } from "./components/Heading";
import RentPlaceView from "./views/RentPlaceView";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/form/*" element={<FormLayout />} />
        <Route path="/reserve/*" element={<ReserveFormLayout />} />

        <Route path="/" element={<BaseLayout />}>
          <Route path="rent-place" element={<RentPlaceView/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
